import { useState, useEffect } from 'react';
const useViewPort = () => {
  const [width, setWidth] = useState(1200);
  const [height, setHeight] = useState(800);
  useEffect(() => {
    const handleWindowResize = () => {
      setWidth(window.outerWidth);
      setHeight(window.innerHeight);
    };
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);
  return {
    width,
    height
  };
};
export default useViewPort;